import React from 'react';

export default function BooksHome(props) {
  const { title, writer, pages, pict } = props;
  const PLACEHOLDER = "https://via.placeholder.com/300x400?text=Book+Cover&bg=efefef&color=333";

  const imgSrc = pict || PLACEHOLDER;

  return (
    <div className="card">
      <div className="w-full max-w-[160px] mx-auto mb-4">
        <img
          className="w-full h-auto object-contain rounded"
          alt={title}
          src={imgSrc}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = PLACEHOLDER;
          }}
        />
      </div>
      <div className="space-y-2">
        <h3 className="text-foreground font-medium">{title}</h3>
        <p className="text-sm text-muted">{writer}</p>
        {pages && <p className="text-xs text-muted">{pages} pages</p>}
      </div>
    </div>
  );
}
